import { render, staticRenderFns } from "./PoinTransfer.vue?vue&type=template&id=2273f585&scoped=true"
import script from "./PoinTransfer.vue?vue&type=script&lang=js"
export * from "./PoinTransfer.vue?vue&type=script&lang=js"
import style0 from "./PoinTransfer.vue?vue&type=style&index=0&id=2273f585&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2273f585",
  null
  
)

export default component.exports